import type { QueryResult } from '@apollo/react-common';
import type { ServiceQueryResult } from '@atlassian/jira-software-deployments-service-query-types';
import type {
	jira_deploymentsPage_getMyPreferences_Query as MyPreferencesQuery,
	jira_deploymentsPage_getMyPreferences_QueryVariables as MyPreferencesQueryVariables,
} from '../__generated_apollo__/jira_deploymentsPage_getMyPreferences_Query';
import {
	DEFAULT_VIEW_CONFIGURATION_PREFERENCE,
	VIEW_CONFIGURATION_PREFERENCE_KEY,
} from '../constants';
import type { ViewConfigurationPreference } from '../types';

const transformJsonString = (jsonString: string): ViewConfigurationPreference | Error => {
	try {
		// When we add more config props to it, merging the result from DEFAULT_VIEW_CONFIGURATION_PREFERENCE will prevent from type errors.
		return {
			...DEFAULT_VIEW_CONFIGURATION_PREFERENCE,
			...JSON.parse(jsonString),
		};
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (e: any) {
		return Error('Invalid ViewConfigurationPreference json string is received');
	}
};

export const transformEnvironmentViewPreferenceQueryResult = ({
	loading,
	error,
	data,
}: QueryResult<
	MyPreferencesQuery,
	MyPreferencesQueryVariables
>): ServiceQueryResult<ViewConfigurationPreference> => {
	if (loading) {
		return {
			loading: true,
		};
	}
	if (error || data == null || data.myPreferences == null) {
		return {
			error: error || new Error('Unexpected error: data or myPreferences field is null.'),
			loading: false,
		};
	}
	if (data.myPreferences[VIEW_CONFIGURATION_PREFERENCE_KEY] == null) {
		return {
			loading: false,
			data: DEFAULT_VIEW_CONFIGURATION_PREFERENCE,
		};
	}

	const result = transformJsonString(data.myPreferences[VIEW_CONFIGURATION_PREFERENCE_KEY]);

	return result instanceof Error
		? {
				error: result,
				loading: false,
			}
		: {
				data: result,
				loading: false,
			};
};
